import { Navigate } from 'react-router-dom';
import { type MouseEvent, useEffect } from 'react';
import { Brand, Icon } from '@recargas-dominicanas/core/components';
import { useLocalStorage } from '@recargas-dominicanas/core/hooks';
import { useBusiness } from '@recargas-dominicanas/core/store';
import { WhatsappIcon } from '@recargas-dominicanas/core/icons';
import { style } from './contact-sales.module.css';

export function ContactSales() {

  const businessStore = useBusiness();
  const localStorage = useLocalStorage();

  useEffect(() => {
    businessStore.fetch();
    const intervalId = setInterval(() => businessStore.fetch(), 2000);
    return () => clearInterval(intervalId);
  }, []);

  function handleClick(event: MouseEvent) {

    event.preventDefault();

    const message = `Saludos, acabo de registrarme, mi ID es ${businessStore.business.id}. Quiero terminar de activar mi cuenta.`;

    const whatsappUrl = localStorage.isWhatsappClicked
      ? 'https://wa.me/18495071210'
      : `https://wa.me/18495071210?text=${encodeURIComponent(message)}`;

    localStorage.setWhatsappClicked(true);

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  }

  if (!businessStore.business?.customer || businessStore.business.customer.status !== 'new') {
    return <Navigate to='/' replace={true}/>;
  }

  return (
    <main className={style.container}>
      <header className={style.header}>
        <Brand/>
      </header>
      <div className={style.content}>
        <div className={style.iconContainer}>
          <Icon icon='rocket_launch' className={style.statusIcon} variant='round'/>
        </div>
        <h1 className={style.heroTitle}>Termina de activar tu cuenta</h1>
        <p className={style.heroDescription}>
          Para terminar de activar tu cuenta, solo necesitas comprar el balance que usarás para vender recargas y cobrar facturas.
        </p>
        <p className={style.activationDescription}>
          Ponte en contacto con nuestro equipo de ventas para saber cómo comprar tu balance y terminar de activar tu cuenta.
        </p>
        <p className={style.contactWhatsapp}>
          <a href='https://wa.me/18495071210' target='_blank' rel='noopener noreferrer' onClick={handleClick}>
            <WhatsappIcon className={style.contactWhatsappIcon}/>
            (849) 507-1210
          </a>
        </p>
        <section className={style.safetySection}>
          <div className={style.safetyHeader}>
            <Icon icon='warning' className={style.safetyIcon} variant='round'/>
            <h2 className={style.safetyTitle}>Recomendaciones de seguridad</h2>
          </div>
          <ul className={style.safetyList}>
            <li className={style.safetyItem}>
              <b>No realices pagos ni compres balance</b> a ninguna persona que visite tu negocio.
            </li>
            <li className={style.safetyItem}>
              <b>No realices depósitos ni transferencias</b> a cuentas personales o de terceros.
            </li>
            <li className={style.safetyItem}>
              Compra balance únicamente a través de las cuentas bancarias a nombre de la empresa: <b>Recargas Dominicanas Redomi E.I.R.L.</b>
            </li>
          </ul>
          <div className={style.officialChannel}>
            <Icon icon='lock' className={style.officialChannelIcon} variant='round'/>
            <span>Utiliza siempre nuestros canales oficiales.</span>
          </div>
        </section>
        <button
          className={style.salesButton}
          type='button'
          onClick={handleClick}>
          <Icon icon='support_agent' className={style.salesButtonIcon}/>
          <span>Hablar con ventas</span>
        </button>
      </div>
    </main>
  );
}
